import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2659a79a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-message" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { toRefs } from 'vue'

  interface Props {
    message: string | string[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    message: null
  },
  setup(__props: any) {

const props = __props as {
    message: string | string[]
  }

  
  const { message } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Array.isArray(_unref(message)))
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(message), (subMessage, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.$t(subMessage)), 1))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(_unref(message))), 1))
  ]))
}
}

})